const loader = document.querySelector('.loader');
export const showLoader = () => loader.classList.remove('loader--hide');
export const hideLoader = () => loader.classList.add('loader--hide');



// WEBPACK FOOTER //
// ./src/helpers/loader.js